import { render, staticRenderFns } from "./MobileMenuSidebar.vue?vue&type=template&id=6bbeb25a&scoped=true&"
import script from "./MobileMenuSidebar.vue?vue&type=script&lang=ts&"
export * from "./MobileMenuSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MobileMenuSidebar.vue?vue&type=style&index=0&id=6bbeb25a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbeb25a",
  null
  
)

export default component.exports